import { render } from "./ModalImportSalle.vue?vue&type=template&id=36a79885"
import script from "./ModalImportSalle.vue?vue&type=script&lang=js"
export * from "./ModalImportSalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__